/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="16.62"
        height="16.61"
        viewBox="0 0 16.62 16.61"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="m15.91 16.61.71-.7-4.28-4.28a7.08 7.08 0 1 0-.71.7Zm-8.86-3.56a6 6 0 1 1 6-6 6 6 0 0 1-6 6Z"
          className="icon-fill"
          fillRule="evenodd"/>
      </svg>
    );
  }
}

Icon.displayName = 'MagnifyingGlassIcon';

export default Icon;
